import { MapPin, Video } from "lucide-react";
import { useClinics } from "@/hooks/useClinics";

const pill = (active) => `rounded-2xl border px-4 py-3 text-left transition-colors ${active ? "border-primary bg-accent" : "border-slate-200 bg-white hover:border-secondary"}`;

export const ClinicChooser = ({ value, onChange, prefix }) => {
  const clinics = useClinics();
  const online = value === "online";
  const physical = clinics.filter((c) => c.type === "clinic");
  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 gap-3">
        <button type="button" className={pill(!online)} onClick={() => online && onChange("")} data-testid={`${prefix}-type-clinic`}>
          <MapPin className="h-4 w-4 text-primary" /><p className="mt-1 text-sm font-medium">In-Clinic</p>
        </button>
        <button type="button" className={pill(online)} onClick={() => onChange("online")} data-testid={`${prefix}-type-online`}>
          <Video className="h-4 w-4 text-primary" /><p className="mt-1 text-sm font-medium">Online Consultation</p>
        </button>
      </div>
      {!online && (
        <div className="grid sm:grid-cols-3 gap-3">
          {physical.map((c) => (
            <button type="button" key={c.id} className={pill(value === c.id)} onClick={() => onChange(c.id)} data-testid={`${prefix}-clinic-${c.id}`}>
              <p className="text-sm font-medium text-[#1A252C]">{c.name}</p>
              <p className="mt-1 text-xs text-muted-foreground">{c.schedule}</p>
            </button>
          ))}
        </div>
      )}
      {online && <p className="text-xs text-muted-foreground">Mon – Sun · 9:00 AM – 9:00 PM</p>}
    </div>
  );
};
